import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-volley-paper font-sans selection:bg-volley-teal/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <PurchaseNotification data-id="element-13" />
    </div>;
}